import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, PRIMARY_OUTLET, Router, RouterLink } from '@angular/router';
import { BreadcrumbOption, NzBreadCrumbComponent, NzBreadCrumbItemComponent } from 'ng-zorro-antd/breadcrumb';
import { filter, startWith, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { NzPageHeaderBreadcrumbDirective } from 'ng-zorro-antd/page-header';
import { NgFor, NgIf } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
    selector: 'hx-breadcrumbs',
    template: `
    <nz-breadcrumb nz-page-header-breadcrumb>
      <nz-breadcrumb-item *ngFor="let bc of breadcrumbs">
        <a *ngIf="bc.url" [routerLink]="bc.url">{{ ('breadcrumb.' + bc.label) | transloco }}</a>
        <span *ngIf="!bc.url">{{ ('breadcrumb' + bc.label) | transloco }}</span>
      </nz-breadcrumb-item>
    </nz-breadcrumb>
  `,
    imports: [NzBreadCrumbComponent, NzPageHeaderBreadcrumbDirective, NgFor, NzBreadCrumbItemComponent, NgIf, RouterLink, TranslocoPipe]
})
export class HxBreadcrumbsComponent implements OnInit, OnDestroy {

  breadcrumbs: BreadcrumbOption[] = [];

  private $destroyed = new Subject<void>();

  constructor(private aRoute: ActivatedRoute, private router: Router) {
  }

  ngOnInit(): void {
    try {
      this.router.events
        .pipe(
          filter(e => e instanceof NavigationEnd),
          takeUntil(this.$destroyed),
          startWith(true) // Trigger initial render.
        )
        .subscribe(() => {
          this.breadcrumbs = this.getBreadcrumbs(this.aRoute.root);
          console.log('this.breadcrumbs', this.breadcrumbs);
        });
    } catch (e) {
      throw e;
    }
  }

  private getBreadcrumbs(route: ActivatedRoute, url: string = '', breadcrumbs: BreadcrumbOption[] = []): BreadcrumbOption[] {
    const children: ActivatedRoute[] = route.children;
    // If there's no sub root, then stop the recurse and returns the generated breadcrumbs.
    if (children.length === 0) {
      return breadcrumbs;
    }
    for (const child of children) {
      if (child.outlet === PRIMARY_OUTLET) {
        // Only parse components in primary router-outlet (in another word, router-outlet without a specific name).
        // Parse this layer and generate a breadcrumb item.
        const routeURL: string = child.snapshot.url
          .map(segment => segment.path)
          .filter(path => path)
          .join('/');
        const nextUrl = url + `/${routeURL}`;
        const breadcrumbLabel = child.snapshot.data['breadcrumb'];
        if (routeURL && breadcrumbLabel) {
          const breadcrumb: BreadcrumbOption = {
            label: breadcrumbLabel,
            params: child.snapshot.params,
            url: nextUrl
          };
          breadcrumbs.push(breadcrumb);
        }
        return this.getBreadcrumbs(child, nextUrl, breadcrumbs);
      }
    }
    return breadcrumbs;
  }

  ngOnDestroy(): void {
    this.$destroyed.next();
    this.$destroyed.complete();
  }
}
